import React, { Children } from 'react';
import { Link } from 'react-router-dom';

import { MDText } from 'i18n-react';

import LocalTexts from '../../utilities/WordpressText.json';

import styles from '../../WordpressPages.scss';

const LocalT = new MDText(LocalTexts);

type ArchiveProps = {
  archive: {
    label: string;
    route: string;
  }[];
}

export const Archive: React.FC<ArchiveProps> = ({ archive }) => {
  if (!archive?.length) {
    return null;
  }

  return (
    <div className={styles.sideBarSection}>
      <h3>{LocalT.translate('archives.title')}</h3>
      <ul>
        {Children.toArray(archive.map((item) => (
          <li key={`${item.route}-${item.label}`}>
            <Link className="mw-link mw-link-blue mw-link-copy" to={item.route}>
              {item.label}
            </Link>
          </li>
        )))}
      </ul>
    </div>
  );
};
